import type { DummyFoods } from './dummyFoods'

export const dough: DummyFoods = {
  Dough: {
    Choux: ['Choux pastry'],
    Filo: ['Filo pastry'],
    Flaky: ['Flaky pastry'],
    Pizza: ['Pizza dough'],
    Puff: ['Puff pastry'],
    Shortcrust: ['Shortcrust pastry'],
  },
}
